import { render, staticRenderFns } from "./MemberWritePwdLayout.vue?vue&type=template&id=89004044&scoped=true&"
import script from "./MemberWritePwdLayout.vue?vue&type=script&lang=js&"
export * from "./MemberWritePwdLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89004044",
  null
  
)

export default component.exports